import React from 'react';
import { CTAButton } from './CTAButton';
const stats = [{
  value: '7',
  label: 'TOMÓW'
}, {
  value: '3',
  label: 'BONUSY'
}, {
  value: '568',
  label: 'STRON'
}, {
  value: '2026',
  label: 'EDYCJA'
}];
export function Hero() {
  return <section className="w-full px-5 pb-14 pt-10 sm:pb-20 sm:pt-16" data-id="element-127" data-mp="9l34tdl96e4i">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-128" data-mp="4mruz2uyk3ma">
        <span className="mb-6 inline-block rounded-full border border-chem/40 bg-chem/10 px-4 py-1.5 text-[10px] font-semibold uppercase tracking-[0.12em] text-chem-deep sm:text-[11px]" data-id="element-129" data-mp="12a0kd8y2xwtk">
          Gotowe do użycia materiały dla nauczycieli chemii
        </span>

        <h1 className="font-display text-[28px] font-bold leading-tight text-ink sm:text-5xl md:text-[54px]" data-id="element-130" data-mp="sddz4j1ud3r0">
          Cały rok chemii — uporządkowany, wizualny i gotowy na Twoją następną lekcję.
        </h1>

        <p className="mt-5 max-w-xl text-sm leading-relaxed text-ink/70 sm:text-lg" data-id="element-131" data-mp="382ff5o82r4ex">
          7 kompletnych tomów i 3 bonusy, które pomagają uczyć klasy 7–8, liceum i technikum bez
          tworzenia materiałów od zera.
        </p>

        <figure className="relative mt-8 w-full max-w-[720px] sm:mt-10" data-id="element-132" data-mp="3o7vl7nivvtyv">
          <div className="relative overflow-hidden rounded-3xl bg-white shadow-[0_24px_50px_-26px_rgba(11,29,58,0.35)]" data-id="element-133" data-mp="39alaige2es47">
            <img src="https://cdn.magicpatterns.com/uploads/wu4SNSxcoVYTPsMHspiMVi/chemia-wizualna-hero-pl-16x9.webp" alt="Nauczycielka trzymająca pudełko Chemia Wizualna™ — 7 tomów gotowych do nauczania" width="1280" height="720" loading="eager" decoding="async" className="block aspect-[16/9] w-full object-cover" data-id="element-134" data-mp="3e8msexzr8le3" />
          </div>
          <figcaption className="px-3 pt-3 text-xs font-medium text-chem-deep/80" data-id="element-135" data-mp="2vj7wtj2u8oh3">
            Wizualna Chemia™ | Edycja 2026
          </figcaption>
        </figure>

        <p className="mt-6 max-w-xl text-sm leading-relaxed text-ink/70 sm:text-base" data-id="element-136" data-mp="2ljpc30f3synz">
          568 stron gotowych do wydruku: jasne wyjaśnienia, ćwiczenia, sprawdziany, projekty, klucze
          odpowiedzi i materiały dla nauczyciela — wszystko po polsku.
        </p>

        <div className="mt-8 w-full max-w-md" data-id="element-137" data-mp="ibyoi9esyw0l">
          <CTAButton label="Uzyskaj natychmiastowy dostęp — 17 USD" microcopy="Jednorazowa płatność • Bez abonamentu • Dostęp cyfrowy od razu" data-id="element-138" data-mp="icrsj2mdn7f1" />
        </div>

        <dl className="mt-9 grid w-full grid-cols-2 overflow-hidden rounded-2xl border border-chem/25 bg-white sm:grid-cols-4" data-id="element-139" data-mp="1b0dsm0webtx5">
          {stats.map((stat, index) => <div key={stat.label} className={`flex flex-col items-center px-3 py-5 sm:py-6 ${index % 2 !== 0 ? 'border-l border-chem/15' : ''} ${index >= 2 ? 'border-t border-chem/15' : ''} sm:border-l sm:border-t-0 sm:first:border-l-0`} data-id="element-140" data-mp="111yagnfcjuzs" data-mpi={index}>
              <dt className="sr-only" data-id="element-141" data-mp="3hqalsx0fjpoq">{stat.label}</dt>
              <dd className="flex flex-col items-center" data-id="element-142" data-mp="1x9b590wn91ck">
                <span className="font-display text-3xl font-bold text-chem sm:text-4xl" data-id="element-143" data-mp="1xaw06rmvemay">
                  {stat.value}
                </span>
                <span className="mt-1 text-[11px] font-semibold uppercase tracking-[0.1em] text-ink/70 sm:text-xs" data-id="element-144" data-mp="269zfdkix2hk6">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}